<template>
  <div>
    <social-header v-if="currentEnv" title="常见问题说明"></social-header>
    <div class="question-list">
      <div class="question-item" v-for="(item,index) in questionList.detailContents" :key="item.id">
        <div class="question-header">
          <div class="question-num">0{{index+1}}</div>
          <div class="question-title">{{item.questionName}}</div>
        </div>
        <div class="question-content">
          <div class="text" v-html="item.answerContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SocialHeader from '../../components/social-header.vue';
import { isWeiXin, isDingDing, changeDocumentTitle } from '../../service/environment'
export default {
  name: 'questionAnswer',
  data: function () {
    return {
      questionList: []
    }
  },
  components: {
    SocialHeader
  },
  computed: {
    currentEnv () {
      if (isWeiXin()) {
        return false
      } else if (isDingDing()) {
        return false
      } else {
        return true
      }
    }
  },
  created () {
    changeDocumentTitle('常见问题说明')
  },
  beforeMount () {
    if (this.$route.params.id) {
      this.questionList = JSON.parse(sessionStorage.getItem('question'))
      console.log('this.questionList', this.questionList)
    } else {
      this.questionList = JSON.parse(sessionStorage.getItem('questionActivity'))
      console.log('this.questionList', this.questionList)
    }
  }
};
</script>

<style scoped>
.question-list{
  width: 100%;
  padding-bottom: 1.88rem;
  box-sizing: border-box;
}
.question-item{
  width: 92%;
  background: #fff;
  margin: 1.25rem auto;
}
.question-header{
  width: 100%;
  height: 4.25rem;
  background-image: url('../../static/img/qa_bg.png');
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  margin-bottom: .38rem;
  padding: 0rem 1.25rem;
  box-sizing: border-box;
}
.question-num{
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1rem;
  color: #FFF;
  text-align: center;
  background-image: url('../../static/img/num_bg.png');
  background-size: 100% 100%;
  margin-right: .63rem;
  font-weight: bold;
  flex-shrink: 0;
}
.question-title{
  width: 17rem;
  font-size: 1.06rem;
  color: #111E36;
  line-height: 1.25rem;
  font-weight: bold;
}
.question-content{
  padding: 0rem 1.25rem;
  box-sizing: border-box;
  padding-bottom: .63rem;
}
.question-content .text{
  margin-bottom: .63rem;
  font-size: .88rem;
  color: #666D7F;
  text-align: left;
  line-height: 1.56rem;
  max-width: 19.69rem;
}
.text >>> img {
  max-width: 19.38rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/questionAnswer.vue